import { SHIPTRACK2 } from "../../actions/portal";

export default function(state = [], action) {
  switch (action.type) {
    case SHIPTRACK2:
      return action.payload;
  }
  return state;
}
